import { Expose } from "class-transformer";

export class AssignPlanningBoardLoanUserDto {
  @Expose()
  userId: string;
}
